import React from "react";
import PropTypes from "prop-types";
import { Col, Container, Row } from "react-bootstrap";
import { graphql } from "gatsby";
import classNames from "classnames";

import RichTextBlock from "./RichTextBlock";

const ContentRow = ({ columns }) => {
    if (!columns?.length) return null;

    return (
        <Container>
            <Row>
                {columns.map((column, index) => (
                    <Col
                        className={classNames(
                            "d-flex flex-column justify-content-center",
                            column.className
                        )}
                        key={column.id}
                        md={{ span: columns.length > 1 ? 6 : 12, order: index }}
                    >
                        <RichTextBlock content={column.copy} />
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export const query = graphql`
    fragment DynamicRow on ContentfulRow {
        sys {
            contentType {
                sys {
                    id
                }
            }
        }
        title
        columns {
            ...DynamicColumn
        }
    }
`;

ContentRow.propTypes = {
    title: PropTypes.string.isRequired,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            className: PropTypes.string,
            copy: PropTypes.shape({
                raw: PropTypes.string.isRequired,
            }).isRequired,
        })
    ).isRequired,
};

export default ContentRow;
